import React    from "react";
import "./CardsCours.css";
import Card from 'react-bootstrap/Card';

function template({cours, icon, nombre, total, texte, couleur}) {
  return (
    <div className="cards-admin py-2">
      <Card style={{borderLeft: `5px solid ${couleur}`}}>
        <Card.Body>
          <div className="d-flex justify-content-between">
            <h5 className="text-uppercase">{cours}</h5>
            {icon}
          </div>
          <div>
            <span className="h1">{nombre}</span>
          </div>
          <div> <strong
            style={{color: `${couleur}`}}
          > {total}</strong> <span>{texte}</span></div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default template;

